import { render, staticRenderFns } from "./ViewStoreCustomer.vue?vue&type=template&id=70ae6871"
import script from "./ViewStoreCustomer.vue?vue&type=script&lang=js"
export * from "./ViewStoreCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports